import { getClient } from "src/api/api.ts";
import { HttpError } from "src/api/httpError.ts";
import { Info } from "src/model/info.ts";

export const fetchApiInfo = async (): Promise<Info> => {
  const {
    data,
    error,
    response: { status },
  } = await getClient().GET("/API/iSEA/V2.1/Info");

  if (error !== undefined) {
    if (error.loggingMessage) {
      throw new HttpError(status, error.loggingMessage);
    }
    throw new HttpError(status, error.message);
  }

  if (data !== undefined) {
    return data;
  }

  throw new Error("Failed to fetch api info");
};
